import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { Button, DialogActions, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { useFilterStore } from 'context/SelectionStore/Manager/FilterStoreProvider.mager'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import { PRIMARY_COLORS } from 'asterX-UI'
import { Modal } from 'asterX-UI/Modals'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import InfiniteScroll from 'react-infinite-scroll-component'
import FilterPanel from 'pages/Desktop/Selection/Manager/components/FilterPanel/FilterPanel'
import CarSelectionCard from 'components/Desktop/Car/CarSelectionCard'
import CarData from 'components/Desktop/Car/CarData'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import HeaderBack from 'components/Desktop/HeaderBack'

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    width: '100%'
  },
  buttonBar: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  rootDiv: {
    display: 'grid',
    gap: 20,
    gridTemplateColumns: 'repeat(3, minmax(160px, 1fr))',
    width: '100%'
  },
  modalButtonBar: {
      gridColumn: '1 / -1'
  }
 
}))
const CarFilter = () => {
  const [activeCar, setActiveCar] = useState(null)
  const [openSelectedCars, setOpenSelectedCars] = useState(false)
  const classes = useStyles()
  const {
    store: { selectedCars, loading },
    funcs: { handleSelectCar, updateSelectedCars }
  } = useSelectionStore()
  const {
    store: { carsList, countFiltered },
    func: { fetchMoreData }
  } = useFilterStore()

  const handleCarClick = car => {
    setActiveCar(car)
  }
  const handleDemonstrationClose = () => {
    setActiveCar(null)
  }

  const handleOpenSelectedCars = () => {
    setOpenSelectedCars(!openSelectedCars)
  }
  const onSelectCar = () => {
    handleSelectCar(activeCar)
    handleDemonstrationClose()
  }
  return (
    <div className={classes.container}>
      <LoaderBackdrop loading={loading} />
      <FilterPanel />
      {carsList?.length > 0 ? (
        <InfiniteScroll
          dataLength={carsList?.length}
          next={fetchMoreData}
          hasMore={countFiltered > carsList?.length}
          height={'74vh'}
          className={classes.rootDiv}
          style={{
            marginTop: 20
          }}
          loader={
            <p style={{ textAlign: 'center' }}>
              <h4>загрузка...</h4>
            </p>
          }
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>Больше нет результатов</b>
            </p>
          }
        >
          {carsList?.map(car => (
            <CarSelectionCard
              car={car}
              isChoosen={!!selectedCars?.find(v => v?.vin === car.vin)}
              onClick={() => handleCarClick(car)}
            />
          ))}
        </InfiniteScroll>
      ) : (
        <div
          style={{
            height: '87vh'
          }}
        >
          Ничего нет
        </div>
      )}
      <div className={classes.buttonBar}>
        <Button
          variant={'contained'}
          disabled={selectedCars?.length === 0}
          onClick={handleOpenSelectedCars}
        >
          Выбрано авто
          <ChipStandard
            backgroundColor={PRIMARY_COLORS[200]}
            color={PRIMARY_COLORS[700]}
          >
            {selectedCars?.length}
          </ChipStandard>
        </Button>
        <Button
          variant={'contained'}
          color={'primary'}
          disabled={selectedCars?.length === 0}
          onClick={updateSelectedCars}
        >
          Продолжить
        </Button>
      </div>
      {activeCar?.id && (
        <Modal
          fullWidth
          maxWidth={'md'}
          open={activeCar}
          onClose={handleDemonstrationClose}
        >
          <CarData vin={activeCar.vin} onClose={handleDemonstrationClose} />
          <DialogActions>
            <Button
              fullWidth
              size={'small'}
              variant={'contained'}
              color={
                !!selectedCars?.find(v => v.vin === activeCar.vin)
                  ? 'secondary'
                  : 'primary'
              }
              onClick={onSelectCar}
            >
              {!!selectedCars?.find(v => v.vin === activeCar.vin)
                ? 'Исключить'
                : 'Добавить'}
            </Button>
          </DialogActions>
        </Modal>
      )}
      {openSelectedCars && (
        <Modal
          fullWidth
          maxWidth={'md'}
          open={openSelectedCars}
          onClose={handleOpenSelectedCars}
        >
          <PageContainerDesktop
            customHeader={
              <HeaderBack onClick={handleOpenSelectedCars}>
                Выбранные авто
                <ChipStandard
                  backgroundColor={PRIMARY_COLORS[200]}
                  color={PRIMARY_COLORS[700]}
                >
                  {selectedCars?.length}
                </ChipStandard>
              </HeaderBack>
            }
          >
            <div className={classes.rootDiv}>
              {selectedCars?.map(car => (
                <CarSelectionCard
                  car={car}
                  isChoosen
                  onClick={() => handleCarClick(car)}
                />
              ))}
              <div className={`${classes.buttonBar} ${classes.modalButtonBar}`}>
                <Button
                  variant={'contained'}
                  color={'primary'}
                  fullWidth
                  onClick={updateSelectedCars}
                >
                  Продолжить
                </Button>
              </div>
            </div>
          </PageContainerDesktop>
        </Modal>
      )}
    </div>
  )
}

export default CarFilter
